import { useLocalStorage } from "@rehooks/local-storage";
import { useEffect, useState } from "react";
import { Navigate } from "react-router";

import useMFA from "hooks/useMFA";
import useTitle from "hooks/useTitle";

// RedirectPage is used by backend, if they need to redirect to app based on localStorage "redirectTo" value
const RedirectPage = () => {
  useTitle("Redirecting...");

  const { shouldUseMFA, shouldRegisterSecurityKey } = useMFA();

  const [redirectTo, , deleteRedirectTo] = useLocalStorage("redirectTo");
  const [redirectTarget] = useState(() => redirectTo || "/");

  const shouldWaitForMFA = shouldRegisterSecurityKey || shouldUseMFA;

  useEffect(() => {
    if (!shouldWaitForMFA) {
      deleteRedirectTo();
    }
  }, [shouldWaitForMFA, deleteRedirectTo]);

  if (shouldRegisterSecurityKey) {
    return <Navigate to="/enable_mfa" replace />;
  }

  if (shouldUseMFA) {
    return <Navigate to="/mfa" replace />;
  }

  return <Navigate to={redirectTarget} replace />;
};

export default RedirectPage;
